export const GRAPH_VIEW = 'GRAPH';
export const LIST_VIEW = 'LIST';
